import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from "vue";
import AppModal from "@/components/AppModal.vue";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'FailedStatusModal',
  props: {
    isOpen: { type: Boolean, default: false }
  },
  emits: ["close", "submit"],
  setup(__props: any, { expose, emit: emits }) {
  expose();

const props = __props as { isOpen: boolean }




const close = () => {
  emits("close");
};

const onOk = () => {
  emits("submit");
  router.push({ name: "Billing" });
};

const __returned__ = { emits, props, close, onOk, withDefaults, AppModal, router }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})